module.exports = __webpack_public_path__ + "logoMil.5785b17e.png";